(function () {
  const root = document.querySelector("[data-hl-pairing]");
  if (!root) return;

  const cards = Array.from(root.querySelectorAll("[data-hl-card]"));
  const form = document.getElementById("pdp-intro-form");
  const priceFormat = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: root.dataset.currency || "USD",
  });
  let cartProductIds = new Set();

  function normalizeSize(title) {
    return String(title || "").toLowerCase().replace(/\s+/g, "");
  }

  function getMainSize() {
    const input = form && form.querySelector(".novProductInput:checked");
    return normalizeSize(input && input.dataset.title);
  }

  function syncCard(card) {
    const select = card.querySelector("[data-hl-size]");
    const option = select.options[select.selectedIndex];
    if (!option) return;
    card.querySelector("[data-hl-size-label]").textContent = option.textContent;
    card.querySelector("[data-hl-price]").textContent = priceFormat.format(
      Number(option.dataset.price) / 100,
    );
  }

  // The pairing follows the size picked above, falling back to 4 oz
  function applySize(card, size) {
    const select = card.querySelector("[data-hl-size]");
    const options = Array.from(select.options).filter((option) => !option.disabled);
    const pick =
      options.find((option) => option.dataset.size === size) ||
      options.find((option) => option.dataset.size === "4oz") ||
      options[0];
    if (pick) select.value = pick.value;
    syncCard(card);
  }

  // The first three products that aren't in the cart yet are suggested
  function render() {
    let shown = 0;
    cards.forEach((card) => {
      const show = shown < 3 && !cartProductIds.has(card.dataset.productId);
      card.hidden = !show;
      if (show) shown += 1;
    });
  }

  function setCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    cartProductIds = new Set(cart.items.map((item) => String(item.product_id)));
    render();
  }

  cards.forEach((card) => {
    const select = card.querySelector("[data-hl-size]");
    const button = card.querySelector("[data-hl-add]");
    select.addEventListener("change", () => syncCard(card));
    button.addEventListener("click", async () => {
      if (button.disabled || typeof window.addToCartExternally !== "function") return;
      button.disabled = true;
      try {
        await window.addToCartExternally(select.value, 1);
      } catch (error) {
        console.error("[PDP Halloween] Add failed:", error);
      } finally {
        button.disabled = false;
      }
    });
  });

  if (form) {
    form.addEventListener("change", (event) => {
      if (!event.target.matches(".novProductInput")) return;
      const size = getMainSize();
      cards.forEach((card) => applySize(card, size));
    });
  }

  const initialSize = getMainSize();
  cards.forEach((card) => applySize(card, initialSize));

  document.addEventListener("cart:updated", (event) => setCart(event.detail && event.detail.cart));
  fetch(window.Shopify.routes.root + "cart.js", { cache: "no-store" })
    .then((response) => response.json())
    .then(setCart)
    .catch(() => {});
})();
